module.exports = {
  allOfTheRemittance: "全部汇款",
  toBeConfirmedUrgent: "待确认紧急",
  theAmountOnTheBillIsYen: "单子金额 円",
  remittanceInformation: "汇款信息",
  customerBalance: "客户余额",
  customerContactInformation: "客户联系信息",
  theRemitter: "汇款人",
  confirmToRemind: "确认提醒",
  afterConfirmationTheRemittanceAmountWillBeReflectedInTheCustomerBalancePleaseBeCareful:
    "确认后汇款额将在客户余额反应，请谨慎操作！",
  remittanceReturnReminder: "汇款回退提醒",
  afterConfirmationThePackingListWillBeReturnedToTheStateToBeRemittedPleaseOperateWithCaution:
    "确认后装箱单将回退到待汇款状态，请谨慎操作！",
  money: "资金",
  contact: "联系方式",
  pleaseUploadPictures: "请上传图片",
  thisParameterCannotBeEmpty: "此参数不能为空",
  searchByCategory: "搜索类别",
  identifyTheTimeToBePaid: "标识待付款时间",
  categoryOfLinks: "链接类别",
  purchaseAnAccount: "购买账户",
  pleaseSelectRemittanceOrder: "请选择汇款订单",
  confirmWhetherToRemitTheSelectedOrder: "是否确认汇款选择的订单",
  transactionNumberRemittance: "交易号汇款",
  remittanceCustomer: "汇款客户",
  remittanceCustomerID: "汇款客户ID",
  confirmationOfRemittance: "汇款确认",
  pickUpContactNumber: "提货联系电话",
  addressAndRemarks: "地址和备注",
  offlinePickupRegistration: "线下提货登记",
  offlineDeliveryModification: "线下提货修改",
  operationSucceeded: "操作成功",
  theGoodsHaveBeenReceivedAndModified: "已收货修改",
  whetherToReturnGoodsToBePickedUp: "是否退回待提货",
  theFinancialDepartmentHasPaid: "财务已付款",
  underInspection: "检品中",
  categoryOfInspectionList: "检品单类别",
  generalInspectionList: "普检单",
  fineInspectionList: "精检单",
  fineCheckReworkOrder: "精检返工单",
  generalInspectionReworkOrder: "普检返工单",
  categoryOfInspectedGoods: "检品类别",
  generalQualityInspector: "普/精检员",
  clothLabelProcessingPersonnel: "布标处理人员",
  printTheInspectionList: "检品单打印",
  dataIsNull: "数据为空",
  goodsToBeSubmittedForInspection: "待提交检品",
  toBeClothLabelProcessing: "待布标处理",
  clothLabelProcessing: "布标处理中",
  productToBeInspected: "待检品复查",
  singleAttributeOfInspection: "检品单属性",
  theFirstInspection: "首检",
  theReInspection: "复检",
  puJian: "普检",
  fineScreening: "精检",
  submitTheReinspectionList: "提出复检单",
  submitTheReinspectionListP: "提出复检单（普检）",
  submitTheReinspectionListJ: "提出复检单（精检）",
  generalprecisionExamination: "普/精检",
  wovenLable: "布标",
  quantityOfGoodsToBeSubmitted: "应检数",
  numberOfItemsSubmittedForInspection: "已提交检品数",
  numberOfGeneralTestPrecisionTestProblems: "普检/精检问题数",
  numberOfLabelLayoutProblems: "布标问题数",
  clothLabelTreatment: "布标处理",
  detailsOfInspectionList: "检品单详情",
  photo: "照片",
  theBusinessEditsTheCommodityProperties: "业务编辑商品属性",
  pendingPrecisionTestNumber: "待普/精检数 ",
  numberOfLabelsToBeLaid: "待布标处理数",
  priceYuan: "价格(元)",
  pleaseEnterRemarks: "请输入备注",
  printTheShippingMarkOfTheInspectionList: "打印检品单唛头",
  cancelTheProductToBeInspected: "取消待检品",
  modifyThePendingPrecisionCheck: "修改待普/精检数",
  exampleChangeTheNumberOfLabelsToBeBlanked: "修改待布标处理数",
  pleaseFirstConfirmWithTheInspection:
    "请先和检品确认是否已经开始检品，已经开始检品的请勿取消！",
  whetherToDiscardTheInspectionList: "是否废弃检品单",
  subjectToRevisionOfPrecisionCheckNumber: "待普/精检数修改",
  confirmTheModification: "确认修改",
  doYouWantToConfirmTheModification: "是否确认修改?",
  operationDataIsNotSelected: "未选择操作数据",
  theNumberOfLabelsToBeDeployedIsChanged: "待布标处理数修改",
  numberOfLabelsToBeLaidAfterModification: "修改后待布标处理数",
  confirmToSubmitTheInspectionList: "是否确认提交检品单",
  selectionOfReasonsForReinspection: "复检原因选择",
  reasonForReinspection: "复检原因",
  whetherToClothLabels: "是否需要布标处理",
  startProcessing: "开始处理",
  inTheProcess: "处理中",
  expired: "已过期",
  couponsSpecifieds: "优惠券生成",
  sum: "金额",
  purchaseData: "购入数据",
  numberOfWarehousesInRakumart: "在rakumart仓库数量",
  numberProposed: "已提出数",
  productName: "商品名称",
  numbersCanBeProposed: "可提出数",
  accessories: "辅料",
  theTotalIsApproximately: "合计约为",
  normalWarehouse: "普通仓库",
  noDataYet: "暂无数据",
  loadingTheNumberOfBoxes: "装箱数量",
  Shipping: "发货中",
  Signed: "已签收",
  shipDate: "发货日期",
  exportExcel: "导出excel",
  theDeletionWasSuccessful: "删除成功",
  signatureSuccessful: "签收成功",
  pleaseSelectData: "请选择数据",
  labelInformation: "标签信息",
  quantitiesCanBeProposed: "可提出数量",
  singlePackingNotes: "单番装箱备注",
  unfold: "展开",
  collapse: "收起",
  proposeQuantities: "提出数量",
  pleaseEnterThisParameter: "请输入这个参数",
  pleaseSelectTheLogisticsMethod: "请选择物流方式",
  confirmTheCreditingTime: "确认入账时间",
  noteDocumentsdeliveryBooks: "注文書・配送書",
  billingType: "账单类型",
  residualGold: "残金",
  withdrawalHistory: "提现记录",
  initiationTime: "发起时间",
  theNumberOfTheFlow: "流水号",
  beneficiaryName: "收款户名",
  beneficiaryAccountNumber: "收款户号",
  withdrawalAmount: "提现金额",
  processingStatus: "处理状态",
  reviewTheCredentials: "查看凭证",
  subAccounts: "子账户",
  login: "登录名",
  clanName: "氏名",
  employeeNumber: "员工编号",
  jobTitle: "职称",
  mailbox: "邮箱",
  prepareForTheExam: "備考",
  shippingAddress: "收货地址",
  domicile: "住所",
  theNumberOfTheCorporation: "法人番号",
  depositConfirmed: "已确认入金",
  remittanceAmountYen: "汇款金额. 円",
  accountBalanceYen: "账户余额. 円",
  applyWithdrawalAmountYen: "申请提现金额. 円",
  voucherForPayment: "打款凭证",
  declineWithdrawalPrompts:
    "确认后，该提现申请将被取消。需要申请人重新提出申请，请确认！",
  refuseToSucceed: "拒绝成功!",
  estimatedDeliveryOrderAmount: "预计配送单金额",
  reasonForRejection: "拒绝原因",
  afterSalesNumber: "售后编号",
  afterSalesStatus: "售后状态",
  operators: "操作人员",
  display: "显示",
  notDisplayed: "不显示",
  theHeadOfTheMinisterialDivisionRevisedTheRemarks: "部长课长修改备注",
  screenshotOfCustomerFeedbackQuestionAdded: "客户反馈问题截图添加",
  afterSalesCostAdjustmentDetails: "客户反馈问题截图添加",
  whetherToConfirmTheDeletion: "是否确认删除?",
  totalAdjustments: "合计调整",
  addAClaimNote: "添加赔款单",
  compensationCap: "赔款上限",
  categoryOfResponsiblePerson: "责任人类别",
  theOrganizationOfTheResponsiblePerson: "责任人所在组织",
  companyEmployees: "公司员工",
  externalLogisticsCompanies: "外部物流公司",
  thirdPartySellers: "第三方卖家",
  selectionOfResponsiblePersons: "责任人选择",
  detailsOfExpensesToBear: "承担费用明细",
  responsiblePersonRole: "责任人角色",
  proportionOfCommitment: "承担比例",
  amountToBeCommitted: "承担金额",
  dutyBearers: "责任承担人",
  associatedResponsiblePerson: "关联责任人",
  companyUndertakes: "公司承担",
  theSumOfTheCompensationRatiosIs100: "赔款比例总和为100",
  firm: "公司",
  confirmationOfCompensation: "赔款确认",
  whetherToConfirmTheClaimNote: "是否确认该赔款单",
  doYouConfirm: "是否确认?",
  isItConfirmedComplete: "是否确认完成?",
  whetherToConfirmTheModification: "是否确认修改?",
  feedback: "意见反馈",
  pleaseEnterTheCustomerID: "请输入客户ID",
  pleaseEnterTheCustomerName: "请输入客户名称",
  correspondingPerson: "对应人员",
  pageLink: "页面链接",
  workWithNotes: "处理备注",
  confirmTheStatus: "确认状态",
  pleaseEnterTheTrackingNumber: "请输入配送单号",
  evaluationTime: "评价时间",
  customerTestimonials: "客户评价",
  overallProductSatisfaction: "商品整体满意度",
  overallServiceSatisfaction: "服务整体满意度",
  logisticsSatisfaction: "物流满意度",
  viewTheDeliveryNote: "查看配送单",
  satisfactionIs1To5Stars: "满意度为1到5星，星级越高越满意",
  whetherTheProductPackagingIsSatisfactory: "商品包装是否满意",
  whetherTheProductIsComplete: "商品是否完整（有无缺失，破损）",
  whetherTheServiceStaffIsInPlaceToMeetYourNeeds:
    "服务人员是否能精准到位满足您的需求",
  whetherTheServiceStaffHasAGoodAttitude: "服务人员是否态度良好",
  whetherTheServiceStaffHandledTheProblemInATimelyManner:
    "服务人员是否处理问题及时",
  whetherYouAreSatisfiedWithTheSpeedOfThisLogistics: "对此物流速度是否满意",
  whetherTheLogisticsService: "物流服务（通关，配送等）是否满意",
  whetherTheLogisticsCostsAreSatisfactory: "物流费用是否满意",
  whetherTheQualityOfTheProductMeetsYourExpectations:
    "商品质量是否符合您的预期",
  overallEvaluationOfTheDeliveryOrder: "配送单整体评价",
  haveAComplaint: "有投诉",
  noComplaint: "无投诉",
  all: "全部",
  excelImport: "Excel导入",
  pleaseSelectAtLeastOneProduct: "请至少选择一个商品",
  areYouSureToDeleteTheSelectedProduct: "确认删除选中的商品吗？",
  theProducerProducts: "该商品因库存不足或其他原因已经找不到，请查看其他商品！",
  pleaseEnterThe1688LiinAKUMARTLink: "请输入1688链接或taobao链接或RAKUMART链接",
  addARow: "添加一行",
  pleaseSelect: "请选择",
  fbaCode: "FBA码",
  productName: "商品名称",
  pleaseEnterTheManagementNumber: "请输入管理番号",
  enterRemarks: "输入备注",
  labelInformation: "标签信息",
  pleaseUploadPictures: "请上传图片",
  photoUploadingInProgress: "写真上传中",
  // -------------------
  pleaseDownloadTUploadTheFile: "请先下载Excel模板表格，再上传文件",
  downloadTemplate: "下载模板",
  pleaseSelectTheUploadFile: "请选择上传文件",
  fileFormatLimitedToXlsAndXlsxOnly: "文件格式仅限Xls和Xlsx",
  afterSuccestentOfTheFile:
    "文件解析成功后，商品将直接在商品库里展示，重复的商品会按照文件编辑好的内容进行覆盖",
  fileUploadInProgress: "文件上传中",
  addResponsiblePerson: "添加责任人",
  oemExclusiveShooting: 'OEM专拍',
  skipFinancialPayments: '跳过财务付款',
  actualAmount: '实际支付',
  applicationQuantity: '申请数量',
  productInquiry: '商品询盘',
  inquiryQuestion: '询盘问题',
  inquiryQuestionPlaceholder: '请输入统一询盘问题',
  pleaseEnterInquiryQuestion: '请输入询盘问题',
  inquiryRecords: '商品询盘记录',
  noInquiryRecords: '暂无询盘记录',
  taskId: '任务ID',
  refinedAnswers: '提炼问答',
  noRefinedAnswers: '暂无提炼结果',
  dialogueContent: '具体对话内容',
  noDialogueContent: '暂无对话内容',
};
